import React, { useState } from 'react';
import { Button, Form, Input, Row, Col } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Link } from 'react-router-dom';
import {
  editInterviewQuestions,
  fetchInterviewQuestions,
} from 'src/services/interview.service';
import styles from '../styles.module.css';

const InterviewEditView = ({ interviewId }) => {
  const [form] = Form.useForm();
  const [questions, setQuestions] = useState([
    'Can you explain your experience working with MERN stack?',
    'How do you ensure the security and scalability of a MERN application?',
    'Can you discuss a challenging MERN project you worked on and how you overcame the difficulties?',
    'Describe your approach to testing and debugging a MERN application.',
    'How do you stay updated with the latest trends and advancements in the MERN stack?',
  ]);
  const [interviewName, setInterviewName] = useState('');
  const interviewUrl = `${window.location.origin}/interview-client/${interviewId}/start`;
  const [copied, setCopied] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleSave = async values => {
    console.log('Form values:', values);

    const ques = [...questions];

    for (let i = 0; i < ques.length; i++) {
      if (values[i.toString()] !== undefined) {
        ques[i] = values[i.toString()];
      }
    }

    editInterviewQuestions({ packetId: interviewId, questions: ques })
      .then(data => {
        if (data.success === true) {
          window.alert('questions saved');
          setQuestions(data.packet.role.questions);
        } else {
          window.alert('error saving questions');
        }
      })
      .catch(err => {
        window.alert('error saving questions');
      });
  };

  const handleCopy = () => {
    setCopied(true);
  };

  const loadInterviewQuestions = async () => {
    setLoader(true);
    fetchInterviewQuestions(interviewId)
      .then(data => {
        setLoader(false);
        console.log(data);
        if (data.success === true) {
          setQuestions(data.packet.role.questions);
          setInterviewName(data.packet.name);
        }
      })
      .catch(err => {
        setLoader(false);
        console.log(err);
      });
  };

  return (
    <div className={styles.container}>
      {loader && <h1>Loading Interview Questions ...</h1>}
      {!loader && (
        <div>
          <h1 className={styles.heading}>{interviewName}</h1>

          <Form form={form} layout="vertical" onFinish={handleSave}>
            {questions.map((question, index) => (
              <Form.Item
                key={index}
                label={`Question ${index + 1}`}
                name={index}
              >
                <Input.TextArea defaultValue={question} />
              </Form.Item>
            ))}
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
            </Form.Item>
          </Form>

          <Row className={styles.urlRow}>
            <Col span={4}>Interview Link:</Col>
            <Col span={25}>
              <Input
                className={styles.urlInput}
                readOnly
                value={interviewUrl}
              />
            </Col>
            <Col span={6}>
              <CopyToClipboard text={interviewUrl} onCopy={handleCopy}>
                <Button className={styles.copyButton} icon={<CopyOutlined />}>
                  {copied ? 'Copied!' : 'Copy URL'}
                </Button>
              </CopyToClipboard>
            </Col>
          </Row>
        </div>
      )}
      <br />
      <div className={styles.dashboardButton}>
        <Link to="/dashboard/">
          <Button type="link" size="large">
            Go To Dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default InterviewEditView;
